import $ from 'jquery';

let addIsHiddenClassOnCookieBar = () => {
  $('#cookie-bar').addClass('cookie-bar-fade-out');
}

let setNewCookie = () => {
  let expDate = new Date();
  expDate.setDate(expDate.getDate() + 365 );
  let newCookie = "osolo = Consent; expires=" + expDate.toUTCString();
  document.cookie = newCookie;
}

let cookiebar = () => {
  if (document.cookie.match(/^(.*;)?\s*osolo\s*=\s*[^;]+(.*)?$/) === null) {
    $('#cookie-bar').removeClass('cookie-bar-is-hidden-from-start');
    setNewCookie();
  }
  else {
    addIsHiddenClassOnCookieBar();
  }
  $('#cookie-button').on('click', addIsHiddenClassOnCookieBar);
}

cookiebar();
